export default __webpack_public_path__ + "images/9bf4e3bead64eefc9863d6f3098a43d8.png";